






























































































































































































































































































































import {
  AgeAgeDTO,
  AgeManagerService,
  LiveManagementCreateLivecarpItemRequest,
  SettingManagementCreateSettingRequest,
} from "@/common/api";
import { LANG } from "@/common/constant";
import QErrors from "@/common/qErrors.vue";
import QPaginate from "@/common/qEventItemPaginate.vue";
import LiveItemPdfComponent from "@/components/admin/live/common/liveItemPdfComponent.vue";
import QInputMultipleLanguage from "@/components/common/qInputMultipleLanguage.vue";
import PaginateModel from "@/model/paginate";
import { error } from "logrocket";
import { PropType } from "vue";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "LiveItemsComponent",
  methods: { error },
  computed: {
    SettingManagementCreateSettingRequest() {
      return SettingManagementCreateSettingRequest;
    },
  },
  components: {
    QInputMultipleLanguage,
    LiveItemPdfComponent,
    QErrors,
    QPaginate,
  },
})
export default class LiveItemsComponent extends Vue {

  get livecarpItems() {
    this.pagination.pageCount = Math.ceil(
      this.value.length / this.pagination.end,
    );
    this.pagination.count = this.value.length;
    const start = (this.pagination.page - 1) * this.pagination.end;
    const end = start + this.pagination.end;

    return this.value.slice(start, end);
  }
  get startIndex() {
    return (this.pagination.page - 1) * this.pagination.end;
  }
  public name: "LiveItemsComponent";
  @Prop({
    type: String,
    default: null,
  })
  public image;

  @Prop({
    type: Object,
    default: {
      ja: true,
      en: true,
      cn: false,
    },
  })
  public languages;

  @Prop({
    type: Array as PropType<LiveManagementCreateLivecarpItemRequest[]>,
    default: () => [
      {
        id: null,
        livecarpId: null,
        code: "",
        isNarita: false,
        producer: "",
        producerEn: null,
        producerCn: null,
        kind: "",
        kindEn: null,
        kindCn: null,
        ageId: null,
        sex: LiveManagementCreateLivecarpItemRequest.sex.FEMALE,
        size: null,
        endTime: null,
        parent: null,
        parentEn: null,
        parentCn: null,
        startPrice: null,
        note: null,
        noteEn: null,
        noteCn: null,
        status: LiveManagementCreateLivecarpItemRequest.status.RELEASE,
      },
    ],
  })
  public value;

  @Prop({
    type: Object,
    default: {},
  })
  public errors;

  @Prop({
    type: Boolean,
    default: false,
  })
  public isEdit;

  public ages: AgeAgeDTO[] = [];

  public gender = [
    {
      id: "male",
      name: this.translateAttribute("live_preview.male"),
    },
    {
      id: "female",
      name: this.translateAttribute("live_preview.female"),
    },
    {
      id: "unknown",
      name: this.translateAttribute("live_preview.unknown"),
    },
  ];

  public pagination = new PaginateModel({
    page: 1,
    pageCount: 0,
    start: 1,
    end: 100,
    count: 0,
  });

  public statuses = [
    {
      id: LiveManagementCreateLivecarpItemRequest.status.RELEASE,
      name: "有効",
    },
    {
      id: LiveManagementCreateLivecarpItemRequest.status.CANCEL,
      name: "中止",
    },
  ];

  public mounted() {
    this.getListAge();
    this.pagination.page =
      Number.parseInt(this.$router.currentRoute.query.page as string) || 1;
  }

  public addLivecarpItem() {
    this.value.push({
      id: null,
      livecarpId: null,
      code: "",
      isNarita: false,
      producer: "",
      producerEn: null,
      producerCn: null,
      kind: "",
      kindEn: null,
      kindCn: null,
      ageId: null,
      sex: LiveManagementCreateLivecarpItemRequest.sex.UNKNOWN,
      size: null,
      endTime: null,
      parent: null,
      parentEn: null,
      parentCn: null,
      startPrice: null,
      note: null,
      noteEn: null,
      noteCn: null,
      status: LiveManagementCreateLivecarpItemRequest.status.RELEASE,
    });
    this.pagination.page = Math.ceil(this.value.length / this.pagination.end);
    this.pagination.count = this.value.length;
    this.doSearch({ page: this.pagination.page }, false);
  }

  public removeLivecarpItem(index) {
    this.value.splice(index, 1);
    if (
      Math.ceil(this.value.length / this.pagination.end) < this.pagination.page
    ) {
      this.pagination.page = this.pagination.page - 1;
    }
    this.pagination.count = this.value.length;
    this.doSearch({ page: this.pagination.page }, false);
  }

  public clearError(name) {
    this.$emit("clearError", name);
  }

  public translateAttribute(attributeName) {
    const currentLang = LANG.JA;
    return this.$t(attributeName, `${currentLang}`);
  }

  public doSearch(query: any = {}, scrollToTop = true): void {
    query = {
      ...query,
    };
    this.pagination.page = query.page || 1;
    this.pagination = new PaginateModel({
      page: this.pagination.page,
      pageCount: this.pagination.pageCount,
      start: this.pagination.start,
      end: this.pagination.end,
      count: this.pagination.count,
    });

    this.$router.push({ query }).catch(() => {
      //
    });
    if (scrollToTop) {
      this.$nextTick(() => {
        const liveItemsElement = this.$refs.liveItemsElement as HTMLElement;
        liveItemsElement.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      });
    }
  }
  public getPageError(errors) {
    if (errors) {
      const keysWithNumbers = Object.keys(errors).filter((key) =>
        key.match(/\d+/),
      );
      const sortedKeys = keysWithNumbers?.sort((a, b) => {
        const numberA = Number.parseInt(a.match(/\d+/)[0]);
        const numberB = Number.parseInt(b.match(/\d+/)[0]);
        return numberA - numberB;
      });
      const firstKeySorted = sortedKeys[0];
      const eventItemIndex = Number.parseInt(firstKeySorted?.match(/\d+/)[0]);
      const page = Math.ceil((eventItemIndex + 1) / this.pagination.end);
      if (page) {
        this.doSearch({ page }, false);
      }
    }
  }

  private async getListAge() {
    const result = await AgeManagerService.adminAge({});

    this.ages = result.data.ages;
  }
}
